import React from 'react';
import PageWrapper from '../components/layouts/PageWrapper';

// Higher-Order Component to wrap pages with unified PageWrapper
// This automatically detects user role and renders appropriate sidebar/header
export const withLayout = (Component) => {
  return function WrappedComponent(props) {
    return (
      <PageWrapper>
        <Component {...props} />
      </PageWrapper>
    );
  };
};

// Keep backward compatibility
export const withAdminLayout = withLayout;
export const withDashboardLayout = withLayout;

export default { withLayout, withAdminLayout, withDashboardLayout };
